/*
 * Copyright 2024 The Backstage Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { Cell as ReactAriaCell } from 'react-aria-components';
import type { CellProps } from '../types';
import { useDefinition } from '../../../hooks/useDefinition';
import { CellDefinition } from '../definition';

/**
 * A low-level table cell primitive for building custom cell content.
 * For standard use cases, prefer `CellText` or `CellProfile`.
 *
 * @public
 */
const Cell = (props: CellProps) => {
  const { ownProps, restProps } = useDefinition(CellDefinition, props);

  return <ReactAriaCell className={ownProps.classes.root} {...restProps} />;
};

Cell.displayName = 'Cell';

export { Cell };
